import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrendingDown = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M9.5625 11.0625C9.5625 10.9062 9.69922 10.75 9.875 10.75H12.5508L8.625 6.82422L6.33984 9.10937C6.22266 9.22656 6.00781 9.22656 5.89063 9.10937L2.45313 5.67188C2.33594 5.55469 2.33594 5.33984 2.45313 5.22266C2.57031 5.10547 2.78516 5.10547 2.90234 5.22266L6.125 8.44531L8.39063 6.16016C8.50781 6.04297 8.72266 6.04297 8.83984 6.16016L13 10.3203V7.625C13 7.46875 13.1367 7.3125 13.3125 7.3125C13.4688 7.3125 13.625 7.46875 13.625 7.625V11.0625C13.625 11.2383 13.4688 11.375 13.3125 11.375H9.875C9.69922 11.375 9.5625 11.2383 9.5625 11.0625Z"
	})
});
const ForwardRef = forwardRef(SvgTrendingDown);
export default ForwardRef;
